(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/syndicate/rules-and-terms/assets/javascripts/rules-and-terms.js') >= 0) return;  svs.modules.push('/components/syndicate/rules-and-terms/assets/javascripts/rules-and-terms.js');
"use strict";


(function (svs) {
  'use strict';

  const logger = svs.core.log.getLogger('syndicate:rules-and-terms');

  const acceptServiceTerms = (id, version, callback) => {
    const data = {
      id,
      version,
      accepted: true
    };
    const options = {
      path: "/player/1/serviceterms/bolags-spel",
      method: 'PUT',
      data: {
        value: JSON.stringify(data)
      }
    };
    svs.core.jupiter.call(options, () => {
      var _svs$syndicate;
      if (svs !== null && svs !== void 0 && (_svs$syndicate = svs.syndicate) !== null && _svs$syndicate !== void 0 && (_svs$syndicate = _svs$syndicate.rules_and_terms) !== null && _svs$syndicate !== void 0 && (_svs$syndicate = _svs$syndicate.data) !== null && _svs$syndicate !== void 0 && _svs$syndicate.serviceTerms) {
        svs.syndicate.rules_and_terms.data.serviceTerms.id = id;
        svs.syndicate.rules_and_terms.data.serviceTerms.version = version;
        svs.syndicate.rules_and_terms.data.serviceTerms.accepted = true;
        svs.syndicate.rules_and_terms.data.serviceTerms.error = false;
      }
      if (typeof callback === 'function') {
        callback(true);
      }
    }, error => {
      logger.info("Generic error: Failed to accept service terms bolags-spel.", svs.core.jupiter.parseErrorResponse(error));
      if (typeof callback === 'function') {
        callback(false);
      }
    });
  };

  const acceptTermsAndCloseSyndicateTermsDialog = (id, version, callback) => {
    logger.info('Customer closing syndicate rules and terms dialog. Saving accepted = true to service terms first.');
    svs.components.analytics.trackEvent({
      category: 'spela-tillsammans',
      action: 'Accepted terms by closing dialog',
      opt_label: version
    });
    const afterAcceptTermsCallback = isAccepted => {
      if (typeof callback === 'function') {
        callback(isAccepted);
      }
    };
    acceptServiceTerms(id, version, afterAcceptTermsCallback);
  };

  const checkAndShowSyndicateTermsDialog = function (afterRulesAndTermsDialogCallback) {
    var _svs$syndicate2, _svs$syndicate3, _svs$accountservices, _svs$accountservices2;
    let isAsync = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let resolve = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    const syndicateTermsAccepted = (svs === null || svs === void 0 || (_svs$syndicate2 = svs.syndicate) === null || _svs$syndicate2 === void 0 || (_svs$syndicate2 = _svs$syndicate2.rules_and_terms) === null || _svs$syndicate2 === void 0 || (_svs$syndicate2 = _svs$syndicate2.data) === null || _svs$syndicate2 === void 0 || (_svs$syndicate2 = _svs$syndicate2.serviceTerms) === null || _svs$syndicate2 === void 0 ? void 0 : _svs$syndicate2.accepted) === undefined ? false : svs === null || svs === void 0 || (_svs$syndicate3 = svs.syndicate) === null || _svs$syndicate3 === void 0 || (_svs$syndicate3 = _svs$syndicate3.rules_and_terms) === null || _svs$syndicate3 === void 0 || (_svs$syndicate3 = _svs$syndicate3.data) === null || _svs$syndicate3 === void 0 || (_svs$syndicate3 = _svs$syndicate3.serviceTerms) === null || _svs$syndicate3 === void 0 ? void 0 : _svs$syndicate3.accepted;
    const id = (svs === null || svs === void 0 || (_svs$accountservices = svs.accountservices) === null || _svs$accountservices === void 0 || (_svs$accountservices = _svs$accountservices.cms_document) === null || _svs$accountservices === void 0 || (_svs$accountservices = _svs$accountservices.data) === null || _svs$accountservices === void 0 || (_svs$accountservices = _svs$accountservices.syndicateTermsDoc) === null || _svs$accountservices === void 0 ? void 0 : _svs$accountservices.id) || '0';
    const version = (svs === null || svs === void 0 || (_svs$accountservices2 = svs.accountservices) === null || _svs$accountservices2 === void 0 || (_svs$accountservices2 = _svs$accountservices2.cms_document) === null || _svs$accountservices2 === void 0 || (_svs$accountservices2 = _svs$accountservices2.data) === null || _svs$accountservices2 === void 0 || (_svs$accountservices2 = _svs$accountservices2.syndicateTermsDoc) === null || _svs$accountservices2 === void 0 ? void 0 : _svs$accountservices2.version) || '0';
    const dialogConfig = {
      icon: 'terms-conditions',
      title: 'För att kunna fortsätta behöver du godkänna villkoren för Spela tillsammans',
      primaryButton: 'Godkänn',
      message: svs.accountservices.cms_document.getTermLink('syndicateTermsDoc', 'Villkor för Spela tillsammans')
    };
    if (!syndicateTermsAccepted) {
      const dialog = new svs.ui.dialog.Confirm({
        branding: svs.ui.dialog.branding.TUR,
        icon: dialogConfig.icon,
        type: svs.ui.dialog.type.INFO,
        allowDimmerClick: false,
        title: dialogConfig.title,
        message: [{
          type: svs.ui.dialog.message.TEXT,
          text: dialogConfig.message
        }],
        actions: [{
          title: dialogConfig.primaryButton,
          callback: () => {
            acceptTermsAndCloseSyndicateTermsDialog(id, version, isAccepted => {
              dialog.close();
              if (isAsync && typeof resolve === 'function') {
                resolve(isAccepted);
              } else if (afterRulesAndTermsDialogCallback && typeof afterRulesAndTermsDialogCallback === 'function') {
                afterRulesAndTermsDialogCallback(isAccepted);
              }
            });
          }
        }]
      });
      svs.ui.dialog.api.add(dialog);
    } else if (isAsync && typeof resolve === 'function') {
      resolve(true);
    } else if (afterRulesAndTermsDialogCallback && typeof afterRulesAndTermsDialogCallback === 'function') {
      afterRulesAndTermsDialogCallback(true);
    }
  };

  const checkAndShowSyndicateTermsDialogAsync = () => new Promise(resolve => {
    checkAndShowSyndicateTermsDialog(undefined, true, resolve);
  });
  svs.syndicate.rules_and_terms.checkAndShowSyndicateTermsDialog = checkAndShowSyndicateTermsDialog;
  svs.syndicate.rules_and_terms.checkAndShowSyndicateTermsDialogAsync = checkAndShowSyndicateTermsDialogAsync;
  svs.syndicate.rules_and_terms.acceptServiceTerms = acceptServiceTerms;
})(svs);

 })(window);